import React from "react";
import { ArrowRight } from "lucide-react";
import { CONFIG } from "../config";
import { Reveal } from "../hooks/useReveal";
import HeroVisual from "./HeroVisual";

function Fact({ label, value }) {
  return (
    <div className="flex flex-col gap-1.5 sm:gap-2 min-w-0">
      <span className="text-[9px] sm:text-[11px] tracking-[0.1em] sm:tracking-[0.14em] uppercase text-[#6D726F] font-medium leading-tight whitespace-nowrap">
        {label}
      </span>
      <span className="text-[15px] sm:text-[17px] text-[#F1F2EF] font-medium">{value}</span>
    </div>
  );
}

export default function Hero() {
  return (
    <section id="overview" className="relative w-full pt-16 sm:pt-20 lg:pt-24 pb-4">
      <div className="mx-auto max-w-[1280px] px-5 sm:px-8 lg:px-[64px]">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-10 items-center">
          {/* Left */}
          <div className="order-1">
            <Reveal>
              <span className="eyebrow-dot micro-label">Real World Asset · Platinum</span>
            </Reveal>
            <Reveal delay={0.05}>
              <h1 className="mt-7 text-[42px] leading-[1.02] sm:text-[56px] lg:text-[76px] font-medium tracking-[-0.03em] text-[#F1F2EF]">
                Own Platinum.
                <br />
                <span className="text-[#B5BAB7]">On-chain.</span>
              </h1>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-7 max-w-[520px] text-[16px] sm:text-[17px] leading-[1.6] text-[#A0A5A2]">
                {CONFIG.token} is {CONFIG.company}’s Platinum Real World Asset token
                — providing precise, fractional digital exposure to Platinum through
                modern on-chain infrastructure.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <div className="mt-9 flex flex-wrap items-center gap-3">
                <a
                  href={CONFIG.buyUrl || "#market"}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 rounded-full bg-[#F0F1EE] px-6 py-3 text-[14px] font-medium text-[#080909] hover:bg-white transition-colors duration-200"
                >
                  Buy {CONFIG.token}
                  <ArrowRight size={16} strokeWidth={2} />
                </a>
                <a
                  href={CONFIG.whitepaperUrl || "#"}
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 rounded-full border border-[#F0F1EE]/15 px-6 py-3 text-[14px] font-medium text-[#F1F2EF] hover:border-[#F0F1EE]/30 hover:bg-[#131515] transition-colors duration-200"
                >
                  Whitepaper
                  <span className="text-[12px] text-[#A0A5A2]">↗</span>
                </a>
              </div>
            </Reveal>

            <Reveal delay={0.2}>
              <div className="mt-12 grid grid-cols-3 gap-2 sm:gap-4 max-w-[440px] border-t hairline pt-7">
                <Fact label="Ticker" value={CONFIG.token} />
                <div className="border-l hairline pl-3 sm:pl-4">
                  <Fact label="Representation" value="10 mg Pt" />
                </div>
                <div className="border-l hairline pl-3 sm:pl-4">
                  <Fact label="Network" value={CONFIG.network} />
                </div>
              </div>
            </Reveal>
          </div>

          {/* Right — platinum visual */}
          <Reveal delay={0.1} className="order-2">
            <HeroVisual />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
